export default __webpack_public_path__ + "static/media/a-to-b.3290f0b4.jpg";